export default __webpack_public_path__ + "static/media/Hospital Marketing.3d1e0e82.png";